"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var GridSettings_1 = require("../model/GridSettings");

var GridSettingsConverter_1 = require("./GridSettingsConverter");
/**
 * Default implementation of {@link GridSettingsConverter}.
 *
 * @author RV
 */


var GridSettingsConverterImpl =
/*#__PURE__*/
function (_GridSettingsConverte) {
  _inherits(GridSettingsConverterImpl, _GridSettingsConverte);

  function GridSettingsConverterImpl() {
    _classCallCheck(this, GridSettingsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridSettingsConverterImpl).apply(this, arguments));
  }

  _createClass(GridSettingsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new GridSettings_1.GridSettings(conversions.documentToClassId(source), conversions.asObjectOpt(source, 'parentId', function (v) {
        return utils_1.Utils.asString(v);
      }), conversions.asObject(source, 'userId', function (v) {
        return utils_1.Utils.asString(v);
      }), conversions.asObject(source, 'nameOfTable', function (v) {
        return utils_1.Utils.asString(v);
      }), conversions.asObjectOpt(source, 'icon', function (v) {
        return utils_1.Utils.asString(v);
      }), conversions.asObjectOpt(source, 'name', function (v) {
        return utils_1.Utils.asString(v);
      }), conversions.asObject(source, 'shared', function (v) {
        return utils_1.Utils.asBool(v);
      }), source.settings);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        parentId: source.parentId,
        userId: source.userId,
        nameOfTable: source.nameOfTable,
        icon: source.icon,
        name: source.name,
        shared: source.shared,
        settings: source.settings
      });
      return result;
    }
  }]);

  return GridSettingsConverterImpl;
}(GridSettingsConverter_1.GridSettingsConverter);

exports.GridSettingsConverterImpl = GridSettingsConverterImpl;